'use strict';

export default angular
  .module('maestro.services.data.questions', [
    'maestro.services.webcore'
  ])
  .service('QuestionsService', QuestionsService)
  .name;

function QuestionsService(webcore, $q) {

  /**
   * Retrieve questions for specific location.
   * @param {number} locationId Location ID to retrieve questions.
   * @param [params] Request parameters.
   * @param {number | number[]} [params.answerStatus] Return questions with requested answer statuses. By default questions with statuses 2 and 3 are returned. Multiple values are supported.
   * @param {boolean} [params.editable] Filter answered questions:
   *   - true - return only editable answered questions,
   *   - false - return only not editable answered questions.
   * @param {string} [params.collectionName] Questions collection name filter.
   * @param {number} [params.appInstanceId] Only retrieve questions for a specific bot.
   * @param {number} [params.limit] Maximum number of questions to return.
   * @param {string} [params.sortBy] Element property used for elements comparison in ordering.
   * @returns {Promise}
   */
  this.getLocationQuestions = (locationId, params) => {
    if (!locationId || isNaN(locationId) || locationId < 0) {
      return $q.reject('Location ID is not specified!');
    }

    let parameters = params || {};
    parameters.limit = params && params.limit ? params.limit : 100;
    parameters.sortBy = params && params.sortBy ? params.sortBy : 'questionWeight';

    return $q.when(
      webcore.services.questions.getLocationQuestions(locationId, parameters)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Answer to location question.
   * @param {number} locationId Location ID to answer question.
   * @param {number} questionId Question ID to answer to.
   * @param {string | number | boolean} answer Answer content.
   * @param {number} [answerStatus] Change answer status, optional.
   * @returns {Promise}
   */
  this.answerSingleQuestion = (locationId, questionId, answer, answerStatus) => {
    if (!questionId || isNaN(questionId) || questionId < 0) {
      return $q.reject('Question ID is not specified!');
    }

    let questionsModel = {
      questions: []
    };
    let answerModel = {
      id: questionId,
      answer: answer
    };

    if (!isNaN(answerStatus) && answerStatus >= 0) {
      answerModel.answerStatus = answerStatus;
    }
    questionsModel.questions.push(answerModel);

    return $q.when(
      webcore.services.questions.answerQuestions(locationId, questionsModel)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

}
